import Config from 'config';
import { ProductCode } from '../types/enums';
import { mapProductIdToProductCode } from './license-util';

type BookParamOptions = {
  edition: string;
  bookCode: string;
  pageNumber?: string;
  isZoom?: string;
};

export function getAgiUrl(license: any): string {
  const agiUrl = new URL(Config.agiURL!);

  let curriculumId: number | null = null;
  if (license?.productId === ProductCode.PREKITT_GSS) {
    curriculumId = ProductCode.PREKITT_GSS;
  } else if (license?.productId === ProductCode.PREKITT_RW) {
    curriculumId = ProductCode.PREKITT_RW;
  }

  if (curriculumId) agiUrl.searchParams.set('curriculum', mapProductIdToProductCode(curriculumId));

  return agiUrl.toString();
}

export function getPathForWorkbook(options: BookParamOptions | any): string {
  const { bookCode, edition, pageNumber, isZoom } = options;

  let path = `/books/${bookCode}/${edition}`;

  path = pageNumber ? `${path}/${pageNumber}` : path;
  path = pageNumber && isZoom ? `${path}/zoom` : path;

  return path;
}

export function changePageNumberInPath(
  { bookCode, edition }: BookParamOptions,
  pageNumber: string | number,
  isZoom: boolean
): string {
  const basePath = `/books/${bookCode}/${edition}/${pageNumber}`;

  return basePath + (isZoom ? '/zoom' : '');
}

export function getPathFromExternalLink(url: string): string {
  return url.replace('/ext', '/books');
}
